module.exports = __webpack_public_path__ + "static/media/layout2-vid.42a02141.svg";